import { LIBELLES_TRI, TRIS, type Tri } from '../tri-liste';

/** Le même sélecteur sur la liste par annonce et sur la recherche. */
export function TriListe({
  tri,
  onChange,
  libelleDefaut,
}: {
  tri: Tri;
  onChange: (tri: Tri) => void;
  /** Remplace le libellé du tri par défaut quand l'API n'ordonne pas par adéquation. */
  libelleDefaut?: string;
}) {
  return (
    <label className="tri-liste">
      <span>Trier par</span>
      <select value={tri} onChange={(e) => onChange(e.target.value as Tri)}>
        {TRIS.map((cle) => (
          <option key={cle} value={cle}>
            {cle === 'defaut' && libelleDefaut ? libelleDefaut : LIBELLES_TRI[cle]}
          </option>
        ))}
      </select>
    </label>
  );
}
